/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
 function fixKlaviyoLinks() {
      document.querySelectorAll('.klaviyo-form-richtext a, .klaviyo-form-richtext a *').forEach(function(el) {
        el.style.setProperty('color', '#5AAAF0', 'important');
        el.style.setProperty('background-color', 'transparent', 'important');
        if (el.tagName === 'A') {
          el.style.setProperty('text-decoration', 'underline', 'important');
        }
      });
    }

    var observer = new MutationObserver(function() {
      if (document.querySelector('.klaviyo-form-richtext a')) {
        fixKlaviyoLinks();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
